<template>
    <div class="view login">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <el-card class="box-card">
                        <div slot="header" class="text-left">
                            <h3>Login</h3>
                        </div>
                        <form class="form-signin" @submit.prevent="submit">
                            <div v-if=errorMessage>
                                <b-alert show variant="danger">{{ errorMessage }}</b-alert>
                            </div>
                            <div :class="{ 'hasError': $v.form.email.$error }">
                                <label for="inputEmail" class="sr-only">Email address</label>
                                <input v-model=form.email type="email" id="inputEmail" class="form-control" placeholder="Email address" required autofocus>
                            </div>
                            <div :class="{ 'hasError': $v.form.password.$error }">
                                <label for="inputPassword" class="sr-only">Password</label>
                                <input v-model=form.password type="password" id="inputPassword" class="form-control" placeholder="Password" required>
                            </div>
                            <el-button class="btn-block mt-10 mb-10" type="primary" native-type="submit" :loading="loading">Login</el-button>
                            <router-link :to="{name:'user-forgot-password'}">I forgot my password</router-link>
                            <div class="mt-20"><a href="https://appold.howrly.nl">Go to old Howrly environment</a></div>
                        </form>
                    </el-card>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators'

export default {
    data () {
        return {
            form: { email: '', password: '' },
            errorMessage: null,
            loading: false

        }
    },

    validations: {
        form: {
            password: { required },
            email: { required, email }
        }
    },

    methods: {
        submit () {
            this.loading = true
            this.errorMessage = null

            this.$v.form.$touch()
            if (this.$v.form.$error) return

            // All validations passed, so try to log in
            this.$auth.login(this.form.email.toLowerCase(), this.form.password)
                .then(response => {
                    this.loading = false
                    if (response.status === 200) {
                        this.$store.dispatch('general/getOrganisation')
                        if (Object.keys(this.$route.query).includes('redirect') && this.$route.query['redirect'].includes('login') === false) {
                            this.$router.push({ path: this.$route.query['redirect'] })
                        } else {
                            this.$router.push({ path: '/' })
                        }
                    } else {
                        this.errorMessage = 'Either the password or the email address is incorrect.'
                    }
                })
                .catch(error => {
                    this.errorMessage = 'Something went wrong, please try again later.'
                    console.log(error)
                })
        }
    },
    created () {
        let refreshToken = localStorage.getItem('refresh_token')
        if (refreshToken) {
            this.$auth.refreshTokens().then(response => {
                if (response.status === 200) {
                    this.$router.push({ path: '/' })
                }
            })
        }
    }
}
</script>

<style lang="scss">
.login {
    margin-top: 50px;
    .card-header {
        background-color: #fff;
    }
    .form-signin {
    width: 100%;
    max-width: 330px;
    padding: 15px;
    margin: 0 auto;
    }
    .form-signin .checkbox {
    font-weight: 400;
    }
    .form-signin .form-control {
    position: relative;
    box-sizing: border-box;
    height: auto;
    padding: 10px;
    font-size: 14px;
    }
    .form-signin .form-control:focus {
    z-index: 2;
    }
    .form-signin input[type="email"] {
    margin-bottom: -1px;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
    }
    .form-signin input[type="password"] {
    margin-bottom: 10px;
    margin-top: 10px;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    }
}
</style>
